import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";
import { PlayerSharedModule } from "@project/player/player-shared.module";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PatientSelectComponent } from "../patient-select/patient-select.component";
import { CreatePlayerDialogComponent } from "@project/player/create-player-dialog.component";
import { MiproSharedModule } from "@mipro/mipro-shared.module";

@NgModule({
    declarations: [PatientSelectComponent],
    imports: [
        CommonModule,
        PrimeNgModule, OverlayPanelModule, ReactiveFormsModule, PlayerSharedModule, MiproSharedModule
    ],
    exports: [PatientSelectComponent, CreatePlayerDialogComponent]
})
export class PatientSelectModule {}